<template>
  <div class="d-flex flex-column justify-content-center align-items-center">
    <div
      class="spinner-border spinner-border-xxl text-primary"
      style="width: 8rem; height: 8rem;"
      role="status"
    >
      <span class="visually-hidden">en cours ...</span>
    </div>
    <div
      v-if="message"
      class="p-4"
    >
      {{ message }}
    </div>
  </div>
</template>

<script>
/**
 * Loader SwissLife
 */
export default {
  name: 'SlLoader',
  props: {
    message: {
      type: String,
      required: false,
      default: ''
    }
  }
}
</script>